import { Action } from 'redux';

export interface CategoriesState {
  loadingCategories: boolean;
  savingCategory: boolean;
  removingCategory: boolean;
  categories: any[];
  selectedIndex: number | null;
  isEditing: boolean;
}

export enum CategoriesActionTypes {
  EDITING_START = '@@categories/EDITING_START',
  EDITING_CANCEL = '@@categories/EDITING_CANCEL',
  GET_CATEGORIES_START = '@@categories/GET_CATEGORIES_START',
  GET_CATEGORIES_SUCCESS = '@@categories/GET_CATEGORIES_SUCCESS',
  GET_CATEGORIES_ERROR = '@@categories/GET_CATEGORIES_ERROR',
  SAVE_CATEGORY_START = '@@categories/SAVE_CATEGORY_START',
  SAVE_CATEGORY_SUCCESS = '@@categories/SAVE_CATEGORY_SUCCESS',
  SAVE_CATEGORY_ERROR = '@@categories/SAVE_CATEGORY_ERROR',
  REMOVE_CATEGORY_START = '@@categories/REMOVE_CATEGORY_START',
  REMOVE_CATEGORY_SUCCESS = '@@categories/REMOVE_CATEGORY_SUCCESS',
  REMOVE_CATEGORY_ERROR = '@@categories/REMOVE_CATEGORY_ERROR',
  CLEAR = '@@categories/CLEAR',
}

export interface CategoriesAction extends Action<CategoriesActionTypes> {
  index?: number;
  categories?: CategoriesState['categories'];
}
